module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.appClass,
    attrs: {
      "id": "app"
    }
  }, [(!_vm.$route.meta.nokeepAlive) ? _c('keep-alive', [_c('router-view')], 1) : _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4eb1bdf9"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 223
// module chunks = 49